import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    GlossaryCalcTerm,
    GlossaryData,
    GlossaryFilters,
    GlossaryTermData,
} from 'GlossaryApp/ts/interfaces/glossary-term.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

/**
 * Glossary Service
 *
 * A service to get additional info about a calc, including the definition and formula (if these are available for the
 * given metric).
 */
@Injectable({
    providedIn: 'root',
})
export class GlossaryService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getGlossaryCalcTerm(calcName: string): Observable<GlossaryCalcTerm | {}> {
        const url = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_CALC_TERM, { calcName });
        return this.ajaxService.getDataObserveBody(url);
    }

    getGlossaryData(filters: Partial<GlossaryFilters>): Observable<GlossaryData> {
        return this.ajaxService.getDataObserveBody(this.urlsService.GLOSSARY.GLOSSARY_DATA, filters);
    }

    getGlossaryTermData(term: string): Observable<GlossaryTermData> {
        const url = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_TERM_DATA, { term });
        return this.ajaxService.getDataObserveBody(url);
    }
}
